'use strict';

var _rollupPluginBabelHelpers = require('../../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var PropTypes = require('prop-types');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

var Textarea = function Textarea(_ref) {
  var className = _ref.className,
      disabled = _ref.disabled,
      defaultErrorText = _ref.error,
      height = _ref.height,
      id = _ref.id,
      label = _ref.label,
      limit = _ref.limit,
      name = _ref.name,
      onChange = _ref.onChange,
      placeholder = _ref.placeholder,
      defaultValue = _ref.value;

  var _useState = React.useState(defaultValue),
      _useState2 = _rollupPluginBabelHelpers.slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  var _useState3 = React.useState(defaultValue.length),
      _useState4 = _rollupPluginBabelHelpers.slicedToArray(_useState3, 2),
      counter = _useState4[0],
      setCounter = _useState4[1];

  var _useState5 = React.useState(!!defaultErrorText),
      _useState6 = _rollupPluginBabelHelpers.slicedToArray(_useState5, 2),
      error = _useState6[0],
      setError = _useState6[1];

  var _useState7 = React.useState(defaultErrorText),
      _useState8 = _rollupPluginBabelHelpers.slicedToArray(_useState7, 2),
      errorText = _useState8[0],
      setErrorText = _useState8[1];

  var updateError = function updateError(textLength) {
    if (!defaultErrorText) {
      if (limit && textLength > limit) {
        setError(true);
      } else if (error) {
        setError(false);
      }
    }
  };

  var updateCounter = function updateCounter(text) {
    if (limit) {
      setCounter(text.length);
      updateError(text.length);
    }
  };

  var onChangeTextarea = function onChangeTextarea(_ref2) {
    var text = _ref2.target.value;
    setValue(text);
    updateCounter(text);
  };

  React.useEffect(function () {
    setError(!!defaultErrorText);
    setErrorText(defaultErrorText);
    updateCounter(value);
  }, [defaultErrorText]);
  React.useEffect(function () {
    setValue(defaultValue);
    updateCounter(defaultValue);
  }, [defaultValue]);
  React.useEffect(function () {
    updateError(value.length);
  }, [limit]);
  React.useEffect(function () {
    if (onChange) {
      onChange({
        value: value,
        error: error
      });
    }
  }, [value, error]);

  var renderFooter = function renderFooter() {
    if (errorText !== '') {
      return /*#__PURE__*/React__default['default'].createElement("div", {
        className: "ds-atom-textarea-footer"
      }, errorText);
    }

    if (limit) {
      return /*#__PURE__*/React__default['default'].createElement("div", {
        className: "ds-atom-textarea-footer"
      }, "".concat(counter, "/").concat(limit));
    }

    return null;
  };

  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: "ds-atom-textarea ".concat(className, " ").concat(error ? 'error' : '', " ").concat(disabled ? 'disabled' : '')
  }, label && /*#__PURE__*/React__default['default'].createElement("label", {
    className: "ds-text-body-base-semibold",
    htmlFor: id
  }, label), /*#__PURE__*/React__default['default'].createElement("textarea", {
    disabled: disabled,
    id: id,
    name: name,
    onChange: onChangeTextarea,
    placeholder: placeholder,
    style: {
      height: height
    },
    value: value
  }), renderFooter());
};

Textarea.propTypes = {
  className: PropTypes__default['default'].string,
  disabled: PropTypes__default['default'].bool,
  error: PropTypes__default['default'].string,
  height: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].number]),
  id: PropTypes__default['default'].string,
  label: PropTypes__default['default'].string,
  limit: PropTypes__default['default'].number,
  name: PropTypes__default['default'].string,
  onChange: PropTypes__default['default'].func,
  placeholder: PropTypes__default['default'].string,
  value: PropTypes__default['default'].string
};
Textarea.defaultProps = {
  className: '',
  disabled: false,
  error: '',
  height: 73,
  id: undefined,
  label: undefined,
  limit: 0,
  name: undefined,
  onChange: undefined,
  placeholder: undefined,
  value: ''
};

module.exports = Textarea;
